import { render, staticRenderFns } from "./BvnForm.vue?vue&type=template&id=617f6ac0&scoped=true"
import script from "./BvnForm.vue?vue&type=script&lang=js"
export * from "./BvnForm.vue?vue&type=script&lang=js"
import style0 from "./BvnForm.vue?vue&type=style&index=0&id=617f6ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f6ac0",
  null
  
)

export default component.exports